import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ActionModel, UserModel } from '../../main/Models';
import { ApiService } from '../../custom-material/Services/api.service';

@Component({
  selector: 'mdr-comments',
  templateUrl: './t_comments.component.html',
  styleUrls: ['./comments.component.less']
})
export class CommentsComponent implements OnInit {

	@Input('action') action:ActionModel;
	@Input('showComments') showComments:boolean = false;

  constructor(private apiService:ApiService) { }

  ngOnInit() {}

  addComment()
  {
    if(this.action.jsonDetails.comments==undefined)
      this.action.jsonDetails.comments = [];

    this.action.jsonDetails.comments.push({note:'', date: new Date(), 
      user: this.apiService.connectedUser,
      edit:true});
    this.action.saveIt = true;
  }
  focusComment(comments, index)
  {
    comments.edit=true; 
  }
  blurComment(comment, index, $event) 
  {
    if($event && $event.code && $event.code=='Enter' && !$event.shiftKey) {
      comment.edit=false;
      
    } else if(!$event || ($event && $event.code && $event.code=='Escape')) {
      if((comment.task=='')) this.action.jsonDetails.comments.splice(index,1);
      else comment.edit=false;
    }
  }

  deleteComment(comm, index)
  {
    this.action.jsonDetails.comments.splice(index,1); 
    comm.confirming=false;
    this.action.saveIt = true;
  }
}
